// extracted by mini-css-extract-plugin
module.exports = {"root":"PlatformFooterMainNavigationSection_root__wkFrc","imageLink":"PlatformFooterMainNavigationSection_imageLink__trOXG"};